if (import.meta.hot) {
	import.meta.hot.accept();
}

import {
	loadApp,
	loadModule,
	unloadModule,
	destroyBehaviorsInContext,
} from '@/core/index';
import 'lazysizes';

// import Header from '@/globals/Header';
import Modal from '@/globals/Modal';
import FadeIn from '@/globals/FadeIn';
// import SetVh from '@/globals/SetVh';

import '@/plugins/logger';
import webfontloader from '@/plugins/webfontloader';
import detectTab from '@/utils/detectTab';
import activeLinks from '@/utils/activeLinks';
import localLinks from '@/utils/localLinks';
import Cookies from 'js-cookie';

webfontloader();

// do it early
if (Cookies.get('site-banner-closed')) {
	document.getElementById('site-banner')?.remove();
}

// load from data-behaviours
const app = loadApp(name => import(`./behaviours/${name}.js`), document.body); // eslint-disable-line

// loadModule({
// 	module: Header,
// 	id: 'header',
// 	node: document.getElementById('header'),
// 	keepAlive: true,
// });

loadModule({
	module: Modal,
	id: 'modal',
	node: document.body,
	keepAlive: false,
});

loadModule({
	module: FadeIn,
	id: 'fade-in',
	node: document.body,
	keepAlive: false,
});

app.hydrate();

// loadModule({
// 	module: FadeIn,
// 	id: 'fade-in',
// 	node: document.body,
// 	keepAlive: false,
// });

// loadModule({
// 	module: SetVh,
// 	id: 'set-vh',
// 	node: document.body,
// 	keepAlive: true,
// });

detectTab();
activeLinks(window.location.pathname);
localLinks();

// document.addEventListener('DOMContentLoaded', () => {
// 	loadModule({
// 		module: FadeIn,
// 		id: 'fade-in',
// 		node: document.body,
// 		keepAlive: false,
// 	});
// });

// https://htmx.org/events
if (typeof htmx !== 'undefined') {
	// Fade during HTMX loading
	// eslint-disable-next-line
	// htmx.on('htmx:beforeSend', () => {
	// 	const results = document.getElementById('results');
	// 	if (results) {
	// 		results.classList.add('is-loading');
	// 	}
	// });

	// Scroll to top of `sprig` container when interacting; but only when `scroll` is in Param (eg not filtering; but probably pagination)
	// eslint-disable-next-line
	htmx.on(
		'htmx:beforeSwap',
		({
			detail: {
				requestConfig: { triggeringEvent },
			},
			target,
		}) => {
			localLinks(target);

			// if (triggeringEvent) {
			// 	const { srcElement } = triggeringEvent;
			// 	if (!srcElement) return;

			// 	const shouldScroll = srcElement.closest('.c-pagination');
			// 	if (srcElement && shouldScroll) {
			// 		window.scrollTo({
			// 			top: target.getBoundingClientRect().top + window.scrollY - 100,
			// 			behavior: 'smooth',
			// 		});
			// 	}
			// }
		}
	);

	// Used if sprig target != results; dont' rely on DOM change to remove `.is-loading`
	htmx.on('htmx:afterSwap', ({ target }) => {
		// Unload modal
		unloadModule('modal');

		// Reload modal
		loadModule({
			module: Modal,
			id: 'modal',
			node: document.body,
			keepAlive: false,
		});

		// Destroy existing behaviors within the swapped context
		const destroyedIds = destroyBehaviorsInContext(target);

		// Rehydrate behaviors in the swapped context
		const targetBehaviours = loadApp(
			name => import(`./behaviours/${name}.js`),
			target
		); // eslint-disable-line

		targetBehaviours.hydrate();
	});
}
